export class StaticResourceProvider {
  constructor(config) {
    this._http = config.http;
    this.customHeaders = {
      headers: {
        "Cache-Control": "no-cache max-age=86400",
      },
    };
  }

  getHelpContent(language) {
    return this._http.get(
      `./translations/help/${language}/helpContent.md`,
      this.customHeaders
    );
  }

  getTimezones() {
    return this._http.get("./timezones.json", this.customHeaders);
  }

  getTranslation(localeKey) {
    return this._http.get(
      `./translations/${localeKey}.json`,
      this.customHeaders
    );
  }
}
